<template>
    
</template>

<script>
    export default {
        name: "journal"
    }
</script>

<style scoped>

</style>
